import React, { useCallback, useMemo } from 'react';
import css from './styles.module.scss';
import { Typography, Tooltip, IconButton, Popover, List, ListItem, ListItemText } from '@material-ui/core';
import { Deal } from '~/features/dashboard/store/models';
import moment from 'moment-timezone';
import { useSelector } from 'react-redux';
import { selectUserData } from '~/features/dashboard/store/selectors';
import Avatar from '@material-ui/core/Avatar';
import AvatarGroup from '@material-ui/lab/AvatarGroup';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { goToEditDealThunk } from '~/features/dashboard/store/actions.thunks';
import { useDispatch } from 'react-redux';
import { isDealFormEditing } from '~/features/dashboard/store/actions';
import { useAppRoute } from '~/utils/hooks/useAppRoute';
import { useRouteMatch } from 'react-router-dom';
import { DateFormat } from '~/common/date-format';
moment.tz.setDefault('GMT');
interface DealCardProps {
    data: Deal;
}
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        popover: {
            pointerEvents: 'none',
        },
        popoverContent: {
            pointerEvents: 'auto',
            // padding: theme.spacing(2),
        },
        root: {
            width: '100%',
            maxWidth: 360,
            // padding: theme.spacing(2),
            backgroundColor: theme.palette.background.paper,
        },
    })
);

// TODO: replace this with ../../deal-card
export const DealCard: React.FC<DealCardProps> = ({ data }) => {
    const classes = useStyles();
    const route = useAppRoute();
    const dispatch = useDispatch();

    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
    const togglePopover = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };
    const open = Boolean(anchorEl);

    const assetCode = data?.assetCode;
    const editDealForm = useCallback(() => {
        dispatch(isDealFormEditing(true));
        dispatch(goToEditDealThunk({ assetCode }));
    }, [assetCode]); // eslint-disable-line react-hooks/exhaustive-deps
    const match = useRouteMatch<{ creatorId: string }>();

    const dealDetailsRoute = useMemo(() => `${match.url}/${data.assetCode}/details`, [match.url, data.assetCode]);
    const goToDealDetails = useCallback(() => route(dealDetailsRoute), [dealDetailsRoute, route]);

    const Users = useSelector(selectUserData);
    const userData = useMemo(() => {
        const userDetails = Users?.contacts.filter((person: any) => person.contactCode === data.companyContactCode);
        return userDetails?.length
            ? userDetails[0]
            : {
                  companyName: '',
                  addressLine1: '',
                  addressLine2: '',
                  addressLine3: '',
                  addressLine4: '',
              };
    }, [Users, data.companyContactCode]);

    return (
        <div className={css.module}>
            <div className={css.topOuter}>
                <div className={css.topOuterleft}>
                    <AvatarGroup className={'avatars-group'} max={3}>
                        {data.image}
                        {data.image ? (
                            <Avatar variant="square" className={css.avatarCustomimg} alt={data.company} src={data.image} />
                        ) : (
                            <Avatar variant="square" className={css.avatarCustomimg} alt={data.company} src={data.image} />
                        )}
                    </AvatarGroup>
                </div>
                <div className={css.topSection}>
                    <div className={css.typography_custom}>
                        <div className={css.typography_customleft}>
                            <Typography className={css.companyName}>{`${data.title}`} </Typography>

                            {userData?.companyName && (
                                <Tooltip style={{ marginTop: '6px' }} title={`${userData?.companyName}`}>
                                    <Typography>{`${
                                        userData?.companyName.length > 25 ? userData?.companyName.slice(0, 25) + '...' : userData?.companyName
                                    }`}</Typography>
                                </Tooltip>
                            )}
                        </div>
                        <div className={css.typography_customright}>
                            <IconButton
                                aria-label="add to favorites"
                                aria-owns={open ? 'mouse-over-popover' : undefined}
                                aria-haspopup="true"
                                onClick={togglePopover}
                            >
                                <MoreVertIcon />
                            </IconButton>
                        </div>
                    </div>
                </div>
            </div>
            <div className={css.bottomSection}>
                <div className={css.infoBlock}>
                    <Typography className="releasedate">Type</Typography>
                    <Typography className="gray-text">{data.dealType}</Typography>
                </div>
                {data.incomePeriod?.start && (
                    <div className={css.infoBlock}>
                        <Typography className="releasedate">Start Date</Typography>
                        {/* <Typography className="gray-text">{moment(data.incomePeriod.start.toString()).format('DD MMM YYYY')}</Typography> */}
                        <Typography className="gray-text">
                            <DateFormat newDate={data.incomePeriod.start} />{' '}
                        </Typography>
                    </div>
                )}
                {data.statementDate && (
                    <div className={css.infoBlock}>
                        <Typography className="releasedate">Statement Date</Typography>
                        <Typography className="gray-text">{data.statementDate === '01/01/0000' ? null : data.statementDate}</Typography>
                    </div>
                )}
            </div>
            <Popover
                id="mouse-over-popover"
                className={classes.popover}
                classes={{
                    paper: classes.popoverContent,
                }}
                open={open}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                onClose={togglePopover}
                disableRestoreFocus
                PaperProps={{ onMouseLeave: togglePopover }}
            >
                <List component="nav" className={classes.root} aria-label="contacts">
                    <ListItem button onClick={goToDealDetails}>
                        <ListItemText primary="View" />
                    </ListItem>
                    <ListItem button onClick={editDealForm}>
                        <ListItemText primary="Edit" />
                    </ListItem>
                </List>
            </Popover>
        </div>
    );
};
